// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  height: 100%;
}

ion-segment-button::part(indicator-background) {
  background: none;
}

ion-segment-button.md::part(indicator-background) {
  height: 0;
}

ion-header {
  box-shadow: none;
  background: #222222;
}

.venue_info_block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px 14px 15px;
}

.lang-icon {
  height: 18px;
  width: 18px;
  border: 1.5px solid white;
  border-radius: 50%;
}

.logo-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  position: absolute;
  left: 0;
  right: 0;
}

.logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 36px;
  width: 86px;
}

.right-slot {
  display: flex;
  align-items: center;
}
.right-slot .table-chip {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #fff;
  height: 26px;
  padding-inline: 9px;
  margin-right: 14px;
}
.right-slot .table-chip-text {
  font-family: AppFontBold;
  font-size: 10px;
  line-height: 120%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #000;
  margin-right: 6px;
}
.right-slot .table-chip-number {
  font-family: Title;
  font-size: 20px;
  line-height: 25px;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #222222;
}

.main_row {
  height: 100%;
}
.main_row .category_col {
  background: #f3f3f3;
}
.main_row .category_col .category_item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 5px 10px 10px;
  margin-top: 1.5px;
  background: #f3f3f3;
  border-radius: 0px;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1.5px solid rgba(79, 97, 79, 0.1019607843);
}
.main_row .category_col .category_item ion-img {
  width: 60px;
  margin-right: 10px;
}
.main_row .category_col .category_item h3 {
  font-family: AppFontBold, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.main_row .category_col .category_item:first-of-type {
  margin-top: 0px;
}
.main_row .category_col .category_item.selected {
  background: var(--ion-color-primary);
  color: #fff;
}
.main_row .category_col .category_item.selected h3 {
  color: white;
}
.main_row .border_top_line {
  width: 100%;
  height: 3px;
  background: #d9d9d9;
}
.main_row .category_name {
  font-family: AppFontMedium;
  font-size: 17px;
  letter-spacing: 0em;
  text-align: left;
  padding: 30px 0px 20px 7px;
}
.main_row .item_row {
  margin: 0 10px;
}
@media (min-width: 991px) {
  .main_row .item_row {
    margin: 0 0px 0 10px;
  }
}
.main_row .catalog_col {
  position: relative;
  overflow: hidden;
  padding: 0;
}
.main_row .order-col {
  padding-top: 23px;
}

.item-col {
  margin-bottom: 12px;
}
@media (min-width: 991px) {
  .item-col {
    margin-bottom: 0px;
    padding: 0px 7px 13px;
  }
}

.category-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 23px;
}
@media (min-width: 991px) {
  .category-row {
    justify-content: flex-start;
    padding-left: 13px;
  }
}
.category-row h2 {
  font-family: Title;
  font-size: 40px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: #222222;
}

.search_col {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_col ion-searchbar {
  --box-shadow: 0px 0px 42px 0px #00000012;
  --border-radius: 10px;
}
.search_col .open_filters {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 10px;
  box-shadow: 0px 0px 42px 0px rgba(0, 0, 0, 0.0705882353);
}
.search_col .open_filters ion-icon {
  zoom: 1.3;
}

.footer-btn-desktop {
  position: absolute;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.footer-btn-desktop ion-button {
  width: 100%;
}

.order_list_row {
  height: 100%;
  display: flex;
}
.order_list_row app-order-content {
  width: 100%;
}

.filers_section {
  background: var(--color-background-alt);
}
@media (max-width: 992px) {
  .filers_section {
    border-bottom: 1px solid #222222;
  }
}

.main-content {
  --padding-start: 0%;
  --padding-end: 0%;
}

.main-content::part(scroll)::-webkit-scrollbar {
  display: none;
}

.main-content::part(scroll) {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.display-flex {
  display: flex;
}

.filters-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  border-top: 1px solid rgba(232, 232, 224, 0.1019607843);
}
.filters-block .common-filter,
.filters-block .vegan-filter {
  height: 100%;
  width: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.filters-block .common-filter {
  border-right: 1px solid rgba(232, 232, 224, 0.1019607843);
}
.filters-block .common-filter .filter-icon {
  height: 100%;
  width: 35px;
  margin-right: 7px;
}
.filters-block .switcher {
  position: relative;
  background: var(--ion-color-primary);
  border-radius: 50px;
  height: 23px;
  width: 63px;
  border: 1px solid #000000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: 6px;
}
.filters-block .switcher .switch-toggler {
  position: absolute;
  left: 0%;
  top: 0%;
  height: 100%;
  width: 42px;
  background-color: #e8e8df;
  border: 1px solid #000000;
  border-radius: 50px;
  transition: left 0.3s ease-in-out, background 0.3s ease-in-out;
}
.filters-block .switcher .switch-toggler.selected {
  left: 32%;
  background: var(--ion-color-primary);
}
.filters-block .filters-text {
  font-family: AppFont;
  font-size: 12px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #fbfbfb;
}

.drink-filters-row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-block: 23px;
}
@media (min-width: 991px) {
  .drink-filters-row {
    justify-content: flex-start;
  }
}

.drink-subcategory-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 14px 12px 14px;
}
.drink-subcategory-filters .subcategory-chip {
  background: transparent;
  border: 1px solid var(--ion-color-primary);
  border-radius: 16px;
  padding: 4px 10px;
  margin: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 28px;
}
.drink-subcategory-filters .subcategory-chip p {
  font-family: AppFont;
  font-size: 10px;
  font-weight: 500;
  color: var(--ion-color-primary);
  margin: 0;
  line-height: 1.2;
}
.drink-subcategory-filters .subcategory-chip.selected {
  background: var(--ion-color-primary);
  border-color: var(--ion-color-primary);
}
.drink-subcategory-filters .subcategory-chip.selected p {
  color: white;
  font-weight: 600;
}
.drink-subcategory-filters .subcategory-chip:hover:not(.selected) {
  background: rgba(255, 255, 255, 0.08);
  border-color: #666;
}

.more {
  min-height: 400px !important;
  width: 100%;
}
@media (max-width: 992px) {
  .more {
    min-height: 250px !important;
    width: 100%;
  }
}

.filter-toggle {
  display: flex;
  justify-content: center;
  padding: 10px 0px;
}

.no_items {
  width: 100%;
  height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.max-height-100 {
  max-height: 100%;
}

.order_basket_block {
  position: absolute;
  z-index: 20;
  height: 99%;
  width: 400px;
  background: #fbfbfb;
  right: -400px;
  top: -1px;
  transition: right 0.3s;
}
.order_basket_block.open {
  right: 0;
  box-shadow: -26px 11px 79px -10px rgb(149, 149, 149);
}
.order_basket_block .order_basket_header .close_basket_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  padding-left: 20px;
  font-family: AppFont;
  font-size: 14px;
  letter-spacing: 0em;
  color: var(--ion-color-black);
  background: #f9f9f9;
}
.order_basket_block .order_basket_header .close_basket_img_col {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d9d9d9;
  padding: 0 16.5px;
  height: 55px;
  width: 55px !important;
}
.order_basket_block .order_basket_header .close_basket_img_col .close_basket_img {
  height: 14px;
  width: 14px;
}

.fixed-notification {
  pointer-events: none;
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #f2dbd9;
  color: var(--color-black);
  font-family: AppFontMedium;
  text-transform: uppercase;
  text-align: center;
  padding: 20px;
  min-height: 0px;
  height: 0px;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
}
.fixed-notification.show-item {
  opacity: 1;
  height: -moz-fit-content;
  height: fit-content;
  min-height: -moz-fit-content;
  min-height: fit-content;
}
@media (max-width: 992px) {
  .fixed-notification {
    bottom: 70px;
    font-size: 14px;
  }
}

.show-basket {
  min-width: 200px;
  position: relative;
  min-height: 35px;
}
.show-basket ion-icon {
  margin-right: 10px;
  color: white;
}
@media (max-width: 992px) {
  .show-basket {
    display: none;
  }
}
.show-basket:hover {
  --background: var(--ion-color-primary) !important;
}
.show-basket h4 {
  color: white;
  font-size: 14px;
  font-family: AppFontBold;
}

.category-list {
  border-bottom: 1px solid var(--ion-color-grey);
}
.category-list ion-segment::-webkit-scrollbar {
  display: none; /* Chrome, Safari */
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none; /* Firefox */
}
.category-list ion-segment {
  border-radius: 0;
  background: transparent;
  margin: 20px 5px;
}
.category-list ion-segment-button::part(native) {
  flex-direction: row;
}
.category-list ion-segment-button.segment-button-checked::part(native) {
  background: #000000;
}
.category-list ion-segment-button.segment-button-checked {
  color: #fff;
}
.category-list ion-segment-button.segment-button-checked .icon {
  background-color: #fff;
}
.category-list ion-segment-button.segment-button-checked .icon-img {
  filter: invert(1);
}
.category-list ion-segment-button {
  --background: var(--ion-color-white);
  --border-radius: 0;
  border: 1px solid var(--ion-color-black);
  min-height: 32px !important;
  color: var(--ion-color-black);
  margin: 0 5px;
  text-transform: capitalize;
  letter-spacing: normal;
}
.category-list ion-segment-button .icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
  background-color: #000000;
  -webkit-mask: url('category-icon.svg') no-repeat center;
  mask: url('category-icon.svg') no-repeat center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
.category-list ion-segment-button .icon-img {
  width: 18px;
  height: auto;
  min-height: 13px;
  margin-right: 5px;
  object-fit: contain;
}
.category-list ion-segment-button p {
  padding-top: 5px;
}

.dark-theme {
  --background: #121212;
  --color: #fff;
  background: #121212;
  color: #fff;
  border-top: 1px solid #383838;
  border-bottom: 1px solid #383838;
}
.dark-theme .category-list-items .category-list-items-title {
  position: relative;
  font-family: AppFontEintrachtOFC;
  font-size: 30px;
}
.dark-theme .category-list-items .category-list-items-title::after {
  content: "";
  position: absolute;
  bottom: -3px;
  left: 0;
  height: 3px;
  width: 60px;
  background: var(--ion-color-eintracht-red);
  border-radius: 3px;
}
.dark-theme .icon-img {
  filter: invert(1);
}
.dark-theme ion-segment-button p {
  font-family: AppFontEintrachtOFCSans;
  font-weight: 400;
}
.dark-theme ion-segment-button.segment-button-checked p {
  font-family: AppFont, sans-serif;
  font-weight: 700;
}

:host(.dark-menu) ion-segment-button::part(native) {
  flex-direction: row;
}
:host(.dark-menu) ion-segment-button.segment-button-checked::part(native) {
  background: #E30613;
  border: 1px solid #E30613;
}
:host(.dark-menu) ion-segment-button.segment-button-checked {
  color: #fff;
}
:host(.dark-menu) ion-segment-button.segment-button-checked .icon {
  background-color: #fff;
}
:host(.dark-menu) ion-segment-button {
  --background: #121212;
  --border-radius: 0;
  border: 1px solid #383838;
  min-height: 32px !important;
  margin: 0 5px;
  color: #fff;
}
:host(.dark-menu) ion-segment-button .icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
  background-color: #fff;
  -webkit-mask: url('category-icon.svg') no-repeat center;
  mask: url('category-icon.svg') no-repeat center;
  -webkit-mask-size: contain;
  mask-size: contain;
}

.category-list-items {
  padding-top: 20px;
}
.category-list-items.dark-theme .category-list-items-title {
  font-family: AppFontEintrachtOFC;
  font-size: 30px;
}
.category-list-items .category-list-items-title {
  font-family: var(--ion-font-family);
  margin: 0 20px;
}

@media (min-width: 991px) {
  .category-list-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    padding: 10px 20px;
  }
}
.dark-theme .category-list-items:not(:first-child) {
  padding-top: 30px;
}

.bottom-bts-block {
  position: absolute;
  bottom: 10px;
  right: 0;
}

.qr-code-btn {
  --background: transparent !important;
  --background-activated: transparent !important;
  --ripple-color: transparent !important;
  --padding-end: 10px;
  --padding-start: 0;
  --padding-top: 10px;
  --border-width: 0;
}
.qr-code-btn ion-img {
  filter: invert(1);
}
.qr-code-btn.eintracht ion-img {
  filter: invert(0);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/menu/menu.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAKA;EACE,YAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAMA;EACE,SAAA;AAHF;;AAMA;EACE,gBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;AAHF;;AAMA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AAJF;;AAOA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,YAAA;EACA,WAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;AALF;AAOE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,gBAAA;EAEA,YAAA;EACA,mBAAA;EACA,kBAAA;AAPJ;AASI;EACE,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,WAAA;EAEA,iBAAA;AARN;AAWI;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,cAAA;AAVN;;AAeA;EACE,YAAA;AAZF;AAcE;EACE,mBAAA;AAZJ;AAcI;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,yDAAA;AAdN;AAgBM;EACE,WAAA;EACA,kBAAA;AAdR;AAiBM;EACE,oCAAA;EACA,eAAA;EACA,iCAAA;AAfR;AAkBM;EACE,eAAA;AAhBR;AAmBM;EACE,oCAAA;EACA,WAAA;AAjBR;AAmBQ;EACE,YAAA;AAjBV;AAuBE;EACE,WAAA;EACA,WAAA;EACA,mBAAA;AArBJ;AAwBE;EACE,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EAEA,0BAAA;AAvBJ;AA0BE;EACE,cAAA;AAxBJ;AC3IE;EDkKA;IAII,oBAAA;EAvBJ;AACF;AA0BE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;AAxBJ;AA2BE;EACE,iBAAA;AAzBJ;;AA6BA;EACE,mBAAA;AA1BF;AC5JE;EDqLF;IAGI,kBAAA;IAEA,qBAAA;EAzBF;AACF;;AA4BA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAzBF;AC1KE;ED8LF;IAQI,2BAAA;IACA,kBAAA;EAxBF;AACF;AA0BE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAxBJ;;AA4BA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzBF;AA2BE;EACE,wCAAA;EACA,qBAAA;AAzBJ;AA4BE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wDAAA;AA1BJ;AA4BI;EACE,SAAA;AA1BN;;AA+BA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AA5BF;AA8BE;EACE,WAAA;AA5BJ;;AAgCA;EACE,YAAA;EACA,aAAA;AA7BF;AA+BE;EACE,WAAA;AA7BJ;;AAiCA;EACE,uCAAA;AA9BF;ACpOE;EDiQF;IAGI,gCAAA;EA5BF;AACF;;AA+BA;EACE,mBAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,aAAA;AA5BF;;AA+BA;EACE,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,YAAA;AA5BF;;AA+BA;EACE,aAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,uDAAA;AA5BF;AA8BE;;EAEE,YAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AA5BJ;AA+BE;EACE,yDAAA;AA7BJ;AA+BI;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AA7BN;AAiCE;EACE,kBAAA;EACA,oCAAA;EACA,mBAAA;EAEA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EAEA,iBAAA;AAjCJ;AAmCI;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EAEA,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,8DAAA;AAlCN;AAoCM;EACE,SAAA;EACA,oCAAA;AAlCR;AAuCE;EACE,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;AArCJ;;AAyCA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAtCF;ACtUE;EDuWF;IAQI,2BAAA;EArCF;AACF;;AAwCA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,yBAAA;AArCF;AAuCE;EACE,uBAAA;EACA,0CAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AArCJ;AAuCI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;EACA,gBAAA;AArCN;AAwCI;EACE,oCAAA;EACA,sCAAA;AAtCN;AAwCM;EACE,YAAA;EACA,gBAAA;AAtCR;AA0CI;EACE,qCAAA;EACA,kBAAA;AAxCN;;AA6CA;EACE,4BAAA;EACA,WAAA;AA1CF;AC/WE;EDuZF;IAII,4BAAA;IACA,WAAA;EAxCF;AACF;;AA2CA;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;AAxCF;;AA2CA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAxCF;;AA2CA;EACE,gBAAA;AAxCF;;AA2CA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,YA3byB;EA4bzB,mBAAA;EAGA,aAAA;EACA,SAAA;EAEA,sBAAA;AA5CF;AA8CE;EACE,QAAA;EAGA,oDAAA;AA5CJ;AAgDI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;AA/CN;AAkDI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;AAhDN;AAkDM;EACE,YAAA;EACA,WAAA;AAhDR;;AAsDA;EACE,oBAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,oCAAA;EACA,UAAA;AAnDF;AAqDE;EACE,UAAA;EACA,wBAAA;EAAA,mBAAA;EACA,4BAAA;EAAA,uBAAA;AAnDJ;ACxcE;EDueF;IAwBI,YAAA;IACA,eAAA;EAnDF;AACF;;AAsDA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAnDF;AAqDE;EACE,kBAAA;EACA,YAAA;AAnDJ;ACxdE;EDogBF;IAWI,aAAA;EAnDF;AACF;AAqDE;EACE,iDAAA;AAnDJ;AAsDE;EACE,YAAA;EACA,eAAA;EACA,wBAAA;AApDJ;;AAwDA;EACE,8CAAA;AArDF;AAuDE;EACE,aAAA,EAAA,mBAAA;EACA,wBAAA,EAAA,YAAA;EACA,qBAAA,EAAA,YAAA;AArDJ;AAwDE;EACE,gBAAA;EACA,uBAAA;EACA,gBAAA;AAtDJ;AAyDE;EACE,mBAAA;AAvDJ;AA0DE;EACE,mBAAA;AAxDJ;AA2DE;EAOE,WAAA;AA/DJ;AAyDI;EACE,sBAAA;AAvDN;AAyDI;EACE,iBAAA;AAvDN;AA4DE;EACE,oCAAA;EACA,kBAAA;EACA,wCAAA;EACA,2BAAA;EACA,6BAAA;EACA,aAAA;EACA,0BAAA;EACA,sBAAA;AA1DJ;AA4DI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,uDAAA;EACA,+CAAA;EACA,0BAAA;EACA,kBAAA;AA1DN;AA4DI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA1DN;AA4DI;EACE,gBAAA;AA1DN;;AA+DA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,gCAAA;AA5DF;AA8DI;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;AA5DN;AA6DM;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,0CAAA;EACA,kBAAA;AA3DR;AA+DA;EACM,iBAAA;AA7DN;AA+DE;EACE,oCAAA;EACA,gBAAA;AA7DJ;AA+DE;EACE,gCAAA;EACA,gBAAA;AA7DJ;;AAoEE;EACE,mBAAA;AAjEJ;AAoEE;EACE,mBAAA;EACA,yBAAA;AAlEJ;AAqEE;EAKE,WAAA;AAvEJ;AAmEI;EACE,sBAAA;AAjEN;AAuEE;EACE,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,aAAA;EACA,WAAA;AArEJ;AAuEI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,uDAAA;EACA,+CAAA;EACA,0BAAA;EACA,kBAAA;AArEN;;AAyEA;EAEE,iBAAA;AAvEF;AAyEI;EACE,gCAAA;EACA,eAAA;AAvEN;AA0EE;EACE,mCAAA;EACA,cAAA;AAxEJ;;ACrnBE;EDksBA;IACI,aAAA;IACA,8BAAA;IACA,SAAA;IACA,kBAAA;EAzEJ;AACF;AA4EC;EACC,iBAAA;AA1EF;;AA8EA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;AA3EF;;AA8EA;EACE,oCAAA;EACA,8CAAA;EACA,sCAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AA3EF;AA6EE;EACE,iBAAA;AA3EJ;AA8EG;EACG,iBAAA;AA5EN","sourcesContent":["@import '../../../theme/mixins';\n\n$container_padding_top: 30px;\n$order_basket_block_width: 400px;\n\n:host {\n  height: 100%;\n}\n\nion-segment-button::part(indicator-background) {\n  background: none;\n}\nion-segment-button.md::part(indicator-background) {\n  height: 0;\n}\n\nion-header {\n  box-shadow: none;\n  background: #222222;\n}\n\n.venue_info_block {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 50px 14px 15px;\n}\n\n.lang-icon {\n  height: 18px;\n  width: 18px;\n  border: 1.5px solid white;\n  border-radius: 50%;\n}\n\n.logo-wrapper {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 100vw;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n.logo {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  height: 36px;\n  width: 86px;\n}\n\n.right-slot {\n  display: flex;\n  align-items: center;\n\n  .table-chip {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    border-radius: 6px;\n    background: #fff;\n\n    height: 26px;\n    padding-inline: 9px;\n    margin-right: 14px;\n\n    &-text {\n      font-family: AppFontBold;\n      font-size: 10px;\n      line-height: 120%;\n      letter-spacing: 0.02em;\n      text-align: center;\n      vertical-align: middle;\n      text-transform: uppercase;\n      color: #000;\n\n      margin-right: 6px;\n    }\n\n    &-number {\n      font-family: Title;\n      font-size: 20px;\n      line-height: 25px;\n      letter-spacing: 0%;\n      text-align: center;\n      vertical-align: middle;\n      text-transform: uppercase;\n\n      color: #222222;\n    }\n  }\n}\n\n.main_row {\n  height: 100%;\n\n  .category_col {\n    background: #f3f3f3;\n\n    .category_item {\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      padding: 10px 5px 10px 10px;\n      margin-top: 1.5px;\n\n      background: #f3f3f3;\n      border-radius: 0px;\n\n      transition: all 0.3s;\n      display: flex;\n      align-items: center;\n      justify-content: flex-start;\n      border-bottom: 1.5px solid #4f614f1a;\n\n      ion-img {\n        width: 60px;\n        margin-right: 10px;\n      }\n\n      h3 {\n        font-family: AppFontBold, sans-serif;\n        font-size: 14px;\n        color: var(--ion-color-secondary);\n      }\n\n      &:first-of-type {\n        margin-top: 0px;\n      }\n\n      &.selected {\n        background: var(--ion-color-primary);\n        color: #fff;\n\n        h3 {\n          color: white;\n        }\n      }\n    }\n  }\n\n  .border_top_line {\n    width: 100%;\n    height: 3px;\n    background: #d9d9d9;\n  }\n\n  .category_name {\n    font-family: AppFontMedium;\n    font-size: 17px;\n    letter-spacing: 0em;\n    text-align: left;\n\n    padding: 30px 0px 20px 7px;\n  }\n\n  .item_row {\n    margin: 0 10px;\n\n    @include desktop {\n      margin: 0 0px 0 10px;\n    }\n  }\n\n  .catalog_col {\n    position: relative;\n    overflow: hidden;\n    padding: 0;\n  }\n\n  .order-col {\n    padding-top: 23px;\n  }\n}\n\n.item-col {\n  margin-bottom: 12px;\n  @include desktop {\n    margin-bottom: 0px;\n    // padding-inline: 13px;\n    padding: 0px 7px 13px;\n  }\n}\n\n.category-row {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-block: 23px;\n\n  @include desktop {\n    justify-content: flex-start;\n    padding-left: 13px;\n  }\n\n  h2 {\n    font-family: Title;\n    font-size: 40px;\n    line-height: 120%;\n    letter-spacing: 0%;\n    text-align: center;\n    text-transform: uppercase;\n    color: #222222;\n  }\n}\n\n.search_col {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  ion-searchbar {\n    --box-shadow: 0px 0px 42px 0px #00000012;\n    --border-radius: 10px;\n  }\n\n  .open_filters {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 42px;\n    height: 42px;\n    border-radius: 10px;\n    box-shadow: 0px 0px 42px 0px #00000012;\n\n    ion-icon {\n      zoom: 1.3;\n    }\n  }\n}\n\n.footer-btn-desktop {\n  position: absolute;\n  bottom: 35px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 40%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n\n  ion-button {\n    width: 100%;\n  }\n}\n\n.order_list_row {\n  height: 100%;\n  display: flex;\n\n  app-order-content {\n    width: 100%;\n  }\n}\n\n.filers_section {\n  background: var(--color-background-alt);\n  @include mobile {\n    border-bottom: 1px solid #222222;\n  }\n}\n\n.main-content {\n  --padding-start: 0%;\n  --padding-end: 0%;\n}\n\n.main-content::part(scroll)::-webkit-scrollbar {\n  display: none;\n}\n\n.main-content::part(scroll) {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n\n.display-flex {\n  display: flex;\n}\n\n.filters-block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 50px;\n  border-top: 1px solid #e8e8e01a;\n\n  .common-filter,\n  .vegan-filter {\n    height: 100%;\n    width: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }\n\n  .common-filter {\n    border-right: 1px solid #e8e8e01a;\n\n    .filter-icon {\n      height: 100%;\n      width: 35px;\n      margin-right: 7px;\n    }\n  }\n\n  .switcher {\n    position: relative;\n    background: var(--ion-color-primary);\n    border-radius: 50px;\n\n    height: 23px;\n    width: 63px;\n    border: 1px solid #000000;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n\n    margin-right: 6px;\n\n    .switch-toggler {\n      position: absolute;\n      left: 0%;\n      top: 0%;\n      height: 100%;\n      width: 42px;\n\n      background-color: #e8e8df;\n      border: 1px solid #000000;\n      border-radius: 50px;\n      transition: left 0.3s ease-in-out, background 0.3s ease-in-out;\n\n      &.selected {\n        left: 32%;\n        background: var(--ion-color-primary);\n      }\n    }\n  }\n\n  .filters-text {\n    font-family: AppFont;\n    font-size: 12px;\n    line-height: 120%;\n    letter-spacing: 0%;\n    vertical-align: middle;\n    text-transform: capitalize;\n    color: #fbfbfb;\n  }\n}\n\n.drink-filters-row {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-block: 23px;\n\n  @include desktop {\n    justify-content: flex-start;\n  }\n}\n\n.drink-subcategory-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 0 14px 12px 14px;\n\n  .subcategory-chip {\n    background: transparent;\n    border: 1px solid var(--ion-color-primary);\n    border-radius: 16px;\n    padding: 4px 10px;\n    margin: 0;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    min-height: 28px;\n\n    p {\n      font-family: AppFont;\n      font-size: 10px;\n      font-weight: 500;\n      color: var(--ion-color-primary);\n      margin: 0;\n      line-height: 1.2;\n    }\n\n    &.selected {\n      background: var(--ion-color-primary);\n      border-color: var(--ion-color-primary);\n\n      p {\n        color: white;\n        font-weight: 600;\n      }\n    }\n\n    &:hover:not(.selected) {\n      background: rgba(255, 255, 255, 0.08);\n      border-color: #666;\n    }\n  }\n}\n\n.more {\n  min-height: 400px !important;\n  width: 100%;\n  @include mobile {\n    min-height: 250px !important;\n    width: 100%;\n  }\n}\n\n.filter-toggle {\n  display: flex;\n  justify-content: center;\n  padding: 10px 0px;\n}\n\n.no_items {\n  width: 100%;\n  height: 70vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.max-height-100 {\n  max-height: 100%;\n}\n\n.order_basket_block {\n  position: absolute;\n  z-index: 20;\n  height: 99%;\n\n  width: $order_basket_block_width;\n  background: #fbfbfb;\n  // box-shadow: 0px 4px 4px 0px #00000040;\n\n  right: calc($order_basket_block_width * (-1));\n  top: -1px;\n\n  transition: right 0.3s;\n\n  &.open {\n    right: 0;\n    -webkit-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n    -moz-box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n    box-shadow: -26px 11px 79px -10px rgba(149, 149, 149, 1);\n  }\n\n  .order_basket_header {\n    .close_basket_col {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background: transparent;\n      padding-left: 20px;\n\n      font-family: AppFont;\n      font-size: 14px;\n      letter-spacing: 0em;\n      color: var(--ion-color-black);\n      background: #f9f9f9;\n    }\n\n    .close_basket_img_col {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      background: #d9d9d9;\n      padding: 0 16.5px;\n      height: 55px;\n      width: 55px !important;\n\n      .close_basket_img {\n        height: 14px;\n        width: 14px;\n      }\n    }\n  }\n}\n\n.fixed-notification {\n  pointer-events: none;\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  background: #f2dbd9;\n  color: var(--color-black);\n  font-family: AppFontMedium;\n  text-transform: uppercase;\n  text-align: center;\n  padding: 20px;\n  min-height: 0px;\n  height: 0px;\n  transition: opacity 0.3s ease-in-out;\n  opacity: 0;\n\n  &.show-item {\n    opacity: 1;\n    height: fit-content;\n    min-height: fit-content;\n  }\n\n  @include mobile {\n    bottom: 70px;\n    font-size: 14px;\n  }\n}\n\n.show-basket {\n  min-width: 200px;\n  position: relative;\n  min-height: 35px;\n\n  ion-icon {\n    margin-right: 10px;\n    color: white;\n  }\n\n  @include mobile {\n    display: none;\n  }\n\n  &:hover {\n    --background: var(--ion-color-primary) !important;\n  }\n\n  h4 {\n    color: white;\n    font-size: 14px;\n    font-family: AppFontBold;\n  }\n}\n\n.category-list {\n  border-bottom: 1px solid var(--ion-color-grey);\n\n  ion-segment::-webkit-scrollbar {\n    display: none; /* Chrome, Safari */\n    -ms-overflow-style: none; /* IE/Edge */\n    scrollbar-width: none; /* Firefox */\n  }\n\n  ion-segment {\n    border-radius: 0;\n    background: transparent;\n    margin: 20px 5px;\n  }\n\n  ion-segment-button::part(native) {\n    flex-direction: row;\n  }\n\n  ion-segment-button.segment-button-checked::part(native) {\n    background: #000000;\n  }\n\n  ion-segment-button.segment-button-checked {\n    .icon {\n      background-color: #fff;\n    }\n    .icon-img {\n      filter: invert(1);\n    }\n    color: #fff;\n  }\n\n  ion-segment-button {\n    --background: var(--ion-color-white);\n    --border-radius: 0;\n    border: 1px solid var(--ion-color-black);\n    min-height: 32px !important;\n    color: var(--ion-color-black);\n    margin: 0 5px;\n    text-transform: capitalize;\n    letter-spacing: normal;\n\n    .icon {\n      width: 18px;\n      height: 18px;\n      margin-right: 5px;\n      background-color: #000000;\n      -webkit-mask: url('../../../assets/eintracht/category-icon.svg') no-repeat center;\n      mask: url('../../../assets/eintracht/category-icon.svg') no-repeat center;\n      -webkit-mask-size: contain;\n      mask-size: contain;\n    }\n    .icon-img {\n      width: 18px;\n      height: auto;\n      min-height: 13px;\n      margin-right: 5px;\n      object-fit: contain;\n    }\n    p {\n      padding-top: 5px;\n    }\n  }\n}\n\n.dark-theme {\n  --background: #121212;\n  --color: #fff;\n  background: #121212;\n  color: #fff;\n  border-top: 1px solid #383838;\n  border-bottom: 1px solid #383838;\n  .category-list-items {\n    .category-list-items-title {\n      position: relative;\n      font-family: AppFontEintrachtOFC;\n      font-size: 30px;\n      &::after {\n        content: \"\";\n        position: absolute;\n        bottom: -3px;\n        left: 0;\n        height: 3px;\n        width: 60px;\n        background: var(--ion-color-eintracht-red);\n        border-radius: 3px;\n    }\n  }\n}\n.icon-img {\n      filter: invert(1);\n    }\n  ion-segment-button p {\n    font-family: AppFontEintrachtOFCSans;\n    font-weight: 400;\n  }\n  ion-segment-button.segment-button-checked p {\n    font-family: AppFont, sans-serif;\n    font-weight: 700;\n  }\n}\n\n\n:host(.dark-menu) {\n\n  ion-segment-button::part(native) {\n    flex-direction: row;\n  }\n\n  ion-segment-button.segment-button-checked::part(native) {\n    background: #E30613;\n    border: 1px solid #E30613;\n  }\n\n  ion-segment-button.segment-button-checked {\n    .icon {\n      background-color: #fff;\n    }\n\n    color: #fff;\n  }\n\n  ion-segment-button {\n    --background: #121212;\n    --border-radius: 0;\n    border: 1px solid #383838;\n    min-height: 32px !important;\n    margin: 0 5px;\n    color:#fff;\n\n    .icon {\n      width: 18px;\n      height: 18px;\n      margin-right: 5px;\n      background-color: #fff;\n      -webkit-mask: url('../../../assets/eintracht/category-icon.svg') no-repeat center;\n      mask: url('../../../assets/eintracht/category-icon.svg') no-repeat center;\n      -webkit-mask-size: contain;\n      mask-size: contain;\n    }\n  }\n}\n.category-list-items {\n  // margin-top: 20px;\n  padding-top: 20px;\n&.dark-theme {\n    .category-list-items-title {\n      font-family: AppFontEintrachtOFC;\n      font-size: 30px;\n    }\n}\n  .category-list-items-title {\n    font-family: var(--ion-font-family);\n    margin: 0 20px;\n  }\n\n}\n@include desktop {\n  .category-list-row{\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      gap: 15px;\n      padding: 10px 20px;\n  }\n}\n.dark-theme {\n\t.category-list-items:not(:first-child) {\n\t\tpadding-top: 30px;\n\t}\n}\n\n.bottom-bts-block {\n  position: absolute;\n  bottom: 10px;\n  right: 0\n}\n\n.qr-code-btn {\n  --background: transparent !important;\n  --background-activated: transparent !important;\n  --ripple-color: transparent !important;\n  --padding-end: 10px;\n  --padding-start: 0;\n  --padding-top: 10px;\n  --border-width: 0;\n\n  ion-img {\n    filter: invert(1);\n  }\n  &.eintracht {\n   ion-img {\n      filter: invert(0);\n    }\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
